import React from 'react'

import { Icon, Show, Switch } from '@app/components/util'
import { LntPopover } from '@app/components/base'
import { ImageRenderer } from '@app/components/renderers'

import { isNullable } from '@app/utils'

import styles from './styles.module.scss'

import type { PriceWithImagesPopoverRendererTypes } from './types'

const fallback = <span>Фотографии отсутствуют</span>

const contentRenderHelper = (imageUrls?: string[] | null, systemComment?: string | null): React.ReactNode => {
  const isValidImageUrls = !!imageUrls?.length

  return (
    <>
      <div className={ styles.priceWithImagesPopoverRenderer__images }>
        <Switch fallback={ fallback }>
          <Switch.Case condition={ isValidImageUrls }>
            { imageUrls?.map((imageUrl, index) => (
              <ImageRenderer
                className={ styles.priceWithImagesPopoverRenderer__image }
                key={ `${imageUrl}_${index}` }
                src={ imageUrl }
                alt='Цена товара'
                fallbackContent='Фото не загружено'
              />
            )) }
          </Switch.Case>
        </Switch>
      </div>

      <Show condition={ !!systemComment }>
        <div className={ styles.priceWithImagesPopoverRenderer__message }>{ systemComment }</div>
      </Show>
    </>
  )
}

export const PriceWithImagesPopoverRenderer: React.FC<PriceWithImagesPopoverRendererTypes> = ({ previewPrice }) => {
  if (isNullable(previewPrice)) return null

  const { price, iconName, photos, systemComment } = previewPrice

  const icon = iconName && (
    <Icon
      className={ styles.priceWithImagesPopoverRenderer__priceIcon }
      size='1.5em'
      name={ iconName }
    />
  )

  return (
    <div className={ styles.priceWithImagesPopoverRenderer }>
      <LntPopover content={ contentRenderHelper(photos, systemComment) }>
        <div className={ styles.priceWithImagesPopoverRenderer__priceWrapper }>
          { price }
          { icon }
        </div>
      </LntPopover>
    </div>
  )
}
